import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import Icon from "@mdi/react";
import { mdiAccountCircleOutline, mdiClose, mdiCheck } from "@mdi/js";
import { Dropdown } from "react-bootstrap";

import styles from "./Navbar.scss";

const Navbar = (props) => {
   let [navBarLeftPos, setNavBarLeftPos] = useState("0");
   let [showFilterTool, setShowFilterTool] = useState(true);
   let [uiIsDark, setUIIsDark] = useState(true);
   let [totalForm, setTotalForm] = useState();
   let [billDay, setBillDay] = useState(null);
   const [currentSubscription, setCurrentSubscription] = useState();

   // New state for controlled Dropdowns:
   const [isDashboardOpen, setIsDashboardOpen] = useState(false);
   const [isRechercheOpen, setIsRechercheOpen] = useState(false);

   const handlerLogout = async () => {
      localStorage.removeItem('comChoice');
      localStorage.removeItem('comChoiceLabel');
      // or localStorage.clear();

      await axios.post('/logout');

      window.location.href = '/home';
   };


   useEffect(() => {
      let themeCookie = Cookies.get("uetheme");
      themeCookie && themeCookie !== props.uiTheme ? props.setUITheme(themeCookie) : null;
      props.uiTheme === "dark" ? setUIIsDark(true) : setUIIsDark(false);
      // display layers panel on init !!!
      props.showCurrentSection("layers");
      props.setLeftPanelOpen(true);
      // count forms this year, current and urgent
      countForms();
   }, []);

   useEffect(() => {
      //(props.leftPanelOpen)?setNavBarLeftPos("146px"):setNavBarLeftPos("64px");
   }, [props.leftPanelOpen]);

   useEffect(() => {
      // console.log(props.userId)
   }, [props.userId]);

   useEffect(() => {
      // console.log(props.userId)
   }, [showFilterTool]);

   useEffect(
      (prev) => {
         props.uiTheme === "dark" ? setUIIsDark(true) : setUIIsDark(false);
      },
      [props.uiTheme]
   );

   useEffect(() => {
      let currentSub = props?.currentSubscription?.plan?.nickname ? props.currentSubscription.plan.nickname : null;
      setCurrentSubscription(currentSub);
   }, [props.currentSubscription]);

   useEffect(() => {
      props.layers_stack.length > 1
         ? localStorage.setItem("layers_stack", JSON.stringify(props.layers_stack))
         : null;
   }, [props.layers_stack]);

   useEffect(() => {
      let totalFormsCheck = props?.currentFormsCount?.length ? props.currentFormsCount.length : null;
      setTotalForm(totalFormsCheck);
   }, [props.currentFormsCount]);

   useEffect(() => {
      countForms();
   }, [props.formsCountByType]);

   useEffect(() => {
      if (props.nextBillingDate) {
         let next = new Date(props.nextBillingDate * 1000);
         let toDay = new Date();
         let Difference_In_Time = toDay.getTime() - next.getTime();
         setBillDay(Math.abs(Math.floor(Difference_In_Time / (1000 * 3600 * 24))));
      }
   }, [props.nextBillingDate]);

   const countForms = () => {
      if (props?.formsCountByType?.length) {
         setTotalForm({
            ...totalForm,
            currents: props.currentFormsCount.length,
            urgents: props.currentFormsCount.reduce(
               (acc, curr, i) =>
                  acc + (curr?.emergency_days <= 0 && curr?.emergency_days >= -8 ? 1 : 0),
               0
            ),
         });
      }
   };

   const navBarLocalStyle = {
      left: navBarLeftPos,
      position: "absolute", // Fixed typo: "postion" -> "position"
   };

   const handleLeftMenuOpen = () => {
      props.setLeftMenuOpen(!props.leftPanelOpen);
   };

   const renderNotificationCount = () => (
      <div className="notification-wrapper">
         <span
            className="badge badge-pill badge-primary ueColorBase"
            style={{
               fontSize: "0.5rem",
               marginRight: "-6px",
               marginTop: "-6px",
               padding: "2px 4px",
               display: props?.unreadNb?.length > 0 ? "inline-block" : "none",
            }}
         >
            {props.unreadNb?.length}
         </span>
         <i className="far fa-bell eu-btn-icon"></i>
      </div>
   );

   const handleToastAsRead = async (id = null) => {
      let url = id ? "/Api/user/notification/read/" + id : "/Api/user/notification/read_all";
      let result = await axios.get(url);
      let filteredNotifications = result.data ? props.unreadNb.filter((e) => e.id !== id) : null;
      props.updateUserInfo({ unreadNotifications: filteredNotifications });
      toast.dismiss(id);
   };

   const handlenotificationClick = () => {
      return (
         <>
            {props.unreadNb.map((item, index) => {
               toast(
                  <div id={"ue-unread_notifications"} className={"w-100"} key={index}>
                     <div className={"w-100 text-right"}>
                        <div className={"btn  btn-sm"}>
                           <Icon path={mdiClose} size={0.5} onClick={(e) => toast.dismiss(item.id)} />
                        </div>
                     </div>
                     <div className={"my-2 font-weight-bold"}>{item?.data?.title}</div>
                     {item?.data?.subtitle ? (
                        <div className={"my-2 font-weight-bold"}>{item?.data?.subtitle}</div>
                     ) : null}
                     <p>{item?.data?.message}</p>
                     <div className={"my-2 italic"} style={{ fontWeight: "0.5rem" }}>
                        {item?.data?.signature}
                     </div>
                     <div
                        className={"btn btn-outline-primary btn-sm rounded"}
                        onClick={(e) => handleToastAsRead(item.id)}
                     >
                        Marquer comme lu
                     </div>
                     <br />
                  </div>,
                  {
                     id: item.id,
                     duration: Infinity,
                     icon: <i className="far fa-bell eu-btn-icon text-primary"></i>,
                     style: {
                        borderRadius: "6px",
                        background: "#253437",
                        color: "#fff",
                        width: "250px",
                        margin: "5px 0 0 0",
                     },
                  }
               );
            })}
            {toast(
               <div className={"d-flex w-100 justify-content-end align-items-center"}>
                  <div
                     id={"hide_all_notifications"}
                     onClick={() => handleToastAsRead()}
                     className={"btn btn-primary btn-sm btn-block text-dark p-1"}
                  >
                     Marquer tout commu lu{" "}
                  </div>
                  <div className={"d-inline-block mx-2 text-white"} style={{ cursor: "pointer" }}>
                     <Icon path={mdiClose} size={0.5} onClick={(e) => toast.dismiss()} />
                  </div>
               </div>,
               {
                  id: "remove_all_notifications",
                  duration: Infinity,
                  icon: null,
                  style: {
                     borderRadius: "6px",
                     background: "#253437",
                     color: "#fff",
                     width: "250px",
                     margin: "45px 0 0 0",
                  },
               }
            )}
         </>
      );
   };

   const handleNav = (evt, linkData) => {
      if (props.isAdmin) {
         window.open("/", "_self");
         return;
      }
      switch (linkData.type) {
         case "url":
            handleClickLink(linkData.link);
            break;
         case "panel":
            props.showCenterSection(false);

            if (linkData.name === props.currentSection) {
               props.setOpenPrintControl(false);
               props.setLeftPanelOpen(false);
               props.showCurrentSection("none");
               props.showCenterSection(false);
            } else if (linkData.name === "print") {
               props.setOpenPrintControl(!props.openPrintControl);
               props.setLeftPanelOpen(false);
            } else if (linkData.name !== "map") {
               props.showCurrentSection(linkData.name);
               props.setLeftPanelOpen(true);
            } else {
               props.showCurrentSection(linkData.name);
               props.setShowSearchPanel(false);
               props.setLeftPanelOpen(false);
            }
            break;
         case "center":
            props.setLeftPanelOpen(false);
            if (props.userId || linkData.name === "product") {
               props.setCurrentCenterPage(linkData.name);
               props.showCurrentSection("dashboard");
               props.showCenterSection("center_zone");
            }
            break;
         default:
            return;
      }
   };

   const handleToggleTheme = (themVal) => {
      if (props.uiTheme === "dark") {
         props.setUITheme("light");
         props.updateTheme("light");
         Cookies.set("uetheme", "light");
         setUIIsDark(false);
      } else {
         props.setUITheme("dark");
         props.updateTheme("dark");
         Cookies.set("uetheme", "dark");
         setUIIsDark(true);
      }
   };

   return (
      <nav
         id="top-nav"
         className="navbar d-none d-md-block fixed-top navbar-expand-md ueNavbar sm py-0 pr-0"
         style={navBarLocalStyle}
      >
         <div className="container-fluid pr-sm-0" style={{ paddingLeft: "7px" }}>
            <div style={{ minWidth: "173px" }}>
               <a className="navbar-brand ml-4 ml-md-0" href="/">
                  {props.theme === "light" ? (
                     <img src="/img/eu_logo_v3.svg" alt="Urba Earth" height="28" />
                  ) : (
                     <img src="/img/eu_logo_v3_white.svg" alt="Urba Earth" height="28" />
                  )}
               </a>
            </div>
            <div className="collapse navbar-collapse" id="navbarMainLinks">
               <ul className="navbar-nav m-auto" style={{ fontWeight: 600 }}>
                  {/* DASHBOARD Dropdown */}
                  <Dropdown
                     id="dropdown-basic"
                     show={isDashboardOpen}
                     onMouseEnter={() => setIsDashboardOpen(true)}
                     onMouseLeave={() => setIsDashboardOpen(false)}
                  >
                     <li
                        className={"nav-item ue-navbar-navlink " + (props.currentSection === "dashboard" ? "active" : "")}
                     >
                        <Dropdown.Toggle as="div" className="nav-link custom-titre-menu">
                           DASHBOARD
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="custom-dropdown-menu">
                           {props.userId ? (
                              <>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    aria-current="dossiers"
                                    href="#"
                                    onClick={(e) =>
                                       handleNav(e, {
                                          type: "center",
                                          name: "dashboard",
                                       })
                                    }
                                 >
                                    Dossier
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    href="#"
                                    onClick={(e) =>
                                       handleNav(e, {
                                          type: "center",
                                          name: "compte",
                                       })
                                    }
                                 >
                                    Compte
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    href="#"
                                    onClick={(e) =>
                                       handleNav(e, {
                                          type: "center",
                                          name: "parameters",
                                       })
                                    }
                                 >
                                    Paramètres
                                 </Dropdown.Item>
                              </>
                           ) : (
                              <Dropdown.Item className="nav-link custom-dropdown-menu" href="/login">
                                 DASHBOARD
                              </Dropdown.Item>
                           )}
                        </Dropdown.Menu>
                     </li>
                  </Dropdown>
                  <li className={"nav-item ue-navbar-navlink " + (props.currentSection === "none" ? "active" : "")}>
                     <a
                        className="nav-link"
                        aria-current="info"
                        href="#"
                        onClick={(e) => handleNav(e, { type: "panel", name: "map" })}
                     >
                        CARTE
                     </a>
                  </li>
                  <li className={"nav-item ue-navbar-navlink " + (props.currentSection === "data" ? "active" : "")}>
                     <a
                        className="nav-link"
                        aria-current="info"
                        href="#"
                        onClick={(e) =>
                           handleNav(e, {
                              type: "panel",
                              name: "data",
                           })
                        }
                     >
                        SÉLECTION
                     </a>
                  </li>
                  {/* RECHERCHE Dropdown */}
                  <Dropdown
                     id="dropdown-basic2"
                     show={isRechercheOpen}
                     onMouseEnter={() => setIsRechercheOpen(true)}
                     onMouseLeave={() => setIsRechercheOpen(false)}
                  >
                     <li className={"nav-item ue-navbar-navlink " + (props.currentSection === "search" ? "active" : "")}>
                        <Dropdown.Toggle as="div" className="nav-link custom-titre-menu">
                           RECHERCHE
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                           className="custom-dropdown-menu"
                           onClick={() => {
                              props.setLeftPanelOpen(false);
                              props.showCenterSection(false);
                              props.setShowSearchPanel(true);
                           }}
                        >
                           {(props.userId && props.entity?.genre?.id === 1) ? (
                              <>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    aria-current="search"
                                    onClick={() => {
                                       props.setFilterChoice("com");
                                    }}
                                 >
                                    Cadastre
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    aria-current="lieu"
                                    onClick={() => {
                                       props.setFilterChoice("lieu");
                                    }}
                                 >
                                    Lieu-dit
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("histo");
                                    }}
                                 >
                                    Parcelles historiques
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("prop");
                                    }}
                                 >
                                    Proprietaire bâti
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("prop_nonbati");
                                    }}
                                 >
                                    Proprietaire terrain
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("indivi");
                                    }}
                                 >
                                    Proprietaire indivision
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("cpte_comm");
                                    }}
                                 >
                                    Proprietaire compte communal
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("zone_urba");
                                    }}
                                 >
                                    Urbanisme - Zone
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("urba_presc_surf");
                                    }}
                                 >
                                    Urbanisme - Prescriptions (Surf)
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_pa");
                                    }}
                                 >
                                    (PA) Permis d'aménager
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_loc");
                                    }}
                                 >
                                    (PC) Permis de construire locaux
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_pc");
                                    }}
                                 >
                                    (PC) Permis de construire logements
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_dp");
                                    }}
                                 >
                                    (DP) Déclarations préalables
                                 </Dropdown.Item>
                              </>
                           ) : (props.userId && props.entity?.genre?.id === 2 && currentSubscription === 'abo-pro') ? (
                              <>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    aria-current="search"
                                    onClick={() => {
                                       props.setFilterChoice("com");
                                    }}
                                 >
                                    Cadastre
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    aria-current="lieu"
                                    onClick={() => {
                                       props.setFilterChoice("lieu");
                                    }}
                                 >
                                    Lieu-dit
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("zone_urba");
                                    }}
                                 >
                                    Urbanisme - Zone
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("urba_presc_surf");
                                    }}
                                 >
                                    Urbanisme - Prescriptions (Surf)
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_pa");
                                    }}
                                 >
                                    (PA) Permis d'aménager
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_loc");
                                    }}
                                 >
                                    (PC) Permis de construire locaux
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_pc");
                                    }}
                                 >
                                    (PC) Permis de construire logements
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_dp");
                                    }}
                                 >
                                    (DP) Déclarations préalables
                                 </Dropdown.Item>
                              </>
                           ) : (props.userId && props.entity?.genre?.id === 2 && currentSubscription === 'abo-pro_2') ? (
                              <>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    aria-current="search"
                                    onClick={() => {
                                       props.setFilterChoice("com");
                                    }}
                                 >
                                    Cadastre
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    aria-current="lieu"
                                    onClick={() => {
                                       props.setFilterChoice("lieu");
                                    }}
                                 >
                                    Lieu-dit
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    aria-current="search"
                                    onClick={() => {
                                       props.setFilterChoice("prop_pers_morale");
                                    }}
                                 >
                                    Propriétaire personne morale
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    aria-current="search"
                                    onClick={() => {
                                       props.setFilterChoice("fonc_resid_zu");
                                    }}
                                 >
                                    Foncier résiduel zone urbaine (U)
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    aria-current="search"
                                    onClick={() => {
                                       props.setFilterChoice("non_bati_zu");
                                    }}
                                 >
                                    Non-bâti zone urbaine
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("zone_urba");
                                    }}
                                 >
                                    Urbanisme - Zone
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("urba_presc_surf");
                                    }}
                                 >
                                    Urbanisme - Prescriptions (Surf)
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_pa");
                                    }}
                                 >
                                    (PA) Permis d'aménager
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_loc");
                                    }}
                                 >
                                    (PC) Permis de construire locaux
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_pc");
                                    }}
                                 >
                                    (PC) Permis de construire logements
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_dp");
                                    }}
                                 >
                                    (DP) Déclarations préalables
                                 </Dropdown.Item>
                              </>
                           ) : (props.userId && props.entity?.genre?.id === 2 && currentSubscription === 'abo-solaire') ? (
                              <>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    aria-current="search"
                                    onClick={() => {
                                       props.setFilterChoice("com");
                                    }}
                                 >
                                    Cadastre
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    aria-current="lieu"
                                    onClick={() => {
                                       props.setFilterChoice("lieu");
                                    }}
                                 >
                                    Lieu-dit
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    aria-current="search"
                                    onClick={() => {
                                       props.setFilterChoice("fonc_resid_a");
                                    }}
                                 >
                                    Foncier résiduel agricole (A)
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={() => {
                                       props.setFilterChoice("parc_zone_a");
                                    }}
                                 >
                                    Parcelles Zone Agricole
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("zone_urba");
                                    }}
                                 >
                                    Urbanisme - Zone
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("urba_presc_surf");
                                    }}
                                 >
                                    Urbanisme - Prescriptions (Surf)
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_pa");
                                    }}
                                 >
                                    (PA) Permis d'aménager
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_loc");
                                    }}
                                 >
                                    (PC) Permis de construire locaux
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_pc");
                                    }}
                                 >
                                    (PC) Permis de construire logements
                                 </Dropdown.Item>
                                 <Dropdown.Item
                                    className="nav-link custom-dropdown-menu"
                                    onClick={(e) => {
                                       props.setFilterChoice("permis_dp");
                                    }}
                                 >
                                    (DP) Déclarations préalables
                                 </Dropdown.Item>
                              </>
                           ) : (
                              <Dropdown.Item className="nav-link custom-dropdown-menu" href="/login">
                                 DASHBOARD
                              </Dropdown.Item>
                           )}
                        </Dropdown.Menu>
                     </li>
                  </Dropdown>

                  <li
                     className={"nav-item ue-navbar-navlink " + (props.currentSection === "layers" ? "active" : "")}
                     onClick={(e) => handleNav(e, { type: "panel", name: "layers" })}
                  >
                     <a className="nav-link" aria-current="data" href="#">
                        DONNÉE
                     </a>
                  </li>
                  <li
                     className={
                        "nav-item ue-navbar-navlink " +
                        (props.currentSection === "reglement" || props.currentSection === "librairie" ? "active" : "")
                     }
                  >
                     <a
                        className="nav-link"
                        aria-current="reglement"
                        href="#"
                        onClick={(e) =>
                           handleNav(e, {
                              type: "panel",
                              name: "librairie",
                           })
                        }
                     >
                        RÉGLEMENT
                     </a>
                  </li>
                  {props?.entity?.genre?.slug === "professionnel" && (
                     <li className="nav-item ue-navbar-navlink">
                        <a
                           className="nav-link"
                           aria-current="tarifs"
                           href="#"
                           onClick={(e) => props.setShowPricing(true)}
                        >
                           TARIFS
                        </a>
                     </li>
                  )}
               </ul>
            </div>
            <div className={"d-none d-lg-flex"}>
               {props.userId ? (
                  <div className="d-flex " id="navbarMainLinks">
                     <ul className="ml-auto ue-btn-folders-group">
                        <li className={"ue-btn-folder "}>
                           <a
                              className={"nav-link"}
                              aria-current="data"
                              href="#"
                              onClick={(e) =>
                                 handleNav(e, {
                                    type: "center",
                                    name: "dashboard",
                                 })
                              }
                           >
                              <span className={"eu-doc-count"}>{totalForm?.currents ? totalForm.currents : 0}</span>
                              <div className="">EN COURS</div>
                           </a>
                        </li>
                        <li
                           className={"ue-btn-folder"}
                           style={{
                              backgroundColor: "var(--theme-urgent)",
                           }}
                        >
                           <a
                              className={"nav-link"}
                              aria-current="data"
                              href="#"
                              onClick={(e) =>
                                 handleNav(e, {
                                    type: "center",
                                    name: "dashboard",
                                 })
                              }
                           >
                              <span className={"eu-doc-count"}>{totalForm?.urgents ? totalForm.urgents : 0}</span>
                              <div className="">URGENT</div>
                           </a>
                        </li>
                        {props?.entity?.genre?.slug === "collective" ? (
                           <li
                              className="ue-btn-folder"
                              style={{ backgroundColor: "var(--theme-portail)" }}
                           >
                              <a
                                 className="nav-link"
                                 aria-current="data"
                                 href="#"
                                 onClick={(e) =>
                                    handleNav(e, {
                                       type: "center",
                                       name: "dashboard",
                                    })
                                 }
                              >
                                 <span className="eu-doc-count">{billDay ? billDay : "!"}</span>
                                 <div>PORTAIL</div>
                              </a>
                           </li>
                        ) : (
                           <li
                              className="ue-btn-folder"
                              style={{ backgroundColor: "var(--theme-portail)" }}
                           >
                              {billDay ? (
                                 <a
                                    className="nav-link"
                                    aria-current="data"
                                    href="#"
                                    onClick={(e) =>
                                       handleNav(e, {
                                          type: "center",
                                          name: "dashboard",
                                       })
                                    }
                                 >
                                    <span className="eu-doc-count">
                                       <Icon path={mdiCheck} size={1} />
                                    </span>
                                    <div>Abonné</div>
                                 </a>
                              ) : (
                                 <a
                                    className="nav-link"
                                    aria-current="data"
                                    href="#"
                                    onClick={(e) => props.setShowPricing(true)}
                                 >
                                    <span className="eu-doc-count">{"!"}</span>
                                    <div>TARIF</div>
                                 </a>
                              )}
                           </li>
                        )}
                     </ul>
                  </div>
               ) : null}
               {props?.unreadNb?.length >= 0 ? (
                  <button className="btn btn-sm mr-2 my-3 my-sm-0 ueColorBase" onClick={handlenotificationClick}>
                     {renderNotificationCount()}
                  </button>
               ) : null}
               <ul className="navbar-nav euNavBigButton mr-0">
                  <li className="nav-item dropdown">
                     <a
                        id="navbarDropdown"
                        className="nav-link dropdown-toggle ueColorBase "
                        href="#"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                     >
                        <Icon path={mdiAccountCircleOutline} size={0.85} className={"mr-3"} color={"#C1C1C1"} />
                        <span className="mr-2" style={{ fontSize: "12px" }}>
                           {props.username}
                        </span>
                     </a>
                     <div
                        className="dropdown-menu dropdown-menu-right text-left ue-usernav-dropdown mt-1"
                        style={{ backgroundColor: "#253437" }}
                        aria-labelledby="navbarDropdown"
                     >
                        {props.userId ? (
                           <>
                              <a
                                 className="ue-nav-dropdown-item d-flex justify-content-between"
                                 href="#"
                                 onClick={(e) =>
                                    handleNav(e, {
                                       type: "center",
                                       name: "dashboard",
                                    })
                                 }
                              >
                                 Formulaires
                              </a>
                              <a
                                 className="ue-nav-dropdown-item d-flex justify-content-between"
                                 href="#"
                                 onClick={(e) =>
                                    handleNav(e, {
                                       type: "center",
                                       name: "compte",
                                    })
                                 }
                              >
                                 Compte
                              </a>
                              <a
                                 className="ue-nav-dropdown-item d-flex justify-content-between"
                                 href="#"
                                 onClick={(e) =>
                                    handleNav(e, {
                                       type: "center",
                                       name: "parameters",
                                    })
                                 }
                              >
                                 Paramètres
                              </a>
                              <a
                                 className="ue-nav-dropdown-item d-flex justify-content-between"
                                 href="#"
                                 onClick={(e) =>
                                    handleNav(e, {
                                       type: "center",
                                       name: "subscription",
                                    })
                                 }
                              >
                                 Abonnement
                              </a>
                              <a
                                 className="ue-nav-dropdown-item d-flex justify-content-between"
                                 href="#"
                                 onClick={(e) =>
                                    handleNav(e, {
                                       type: "center",
                                       name: "contact",
                                    })
                                 }
                              >
                                 Contact
                              </a>
                              <a className="ue-nav-dropdown-item d-flex justify-content-between" href="#">
                                 Mentions légales et conditions (CGV)
                              </a>
                           </>
                        ) : (
                           <a className="dropdown-item d-flex justify-content-between" href={"/login"}>
                              Connexion
                           </a>
                        )}
                        {props.role && props.role === "admin" ? (
                           <a className="ue-nav-dropdown-item d-flex justify-content-between" href="/admin">
                              Administration
                           </a>
                        ) : null}
                        {props.userId ? (
                           <a
                              className="ue-nav-dropdown-item d-flex justify-content-between"
                              href="#"
                              onClick={handlerLogout}
                           >
                              <div>Déconnexion</div>
                              <div>
                                 <svg
                                    width="15"
                                    height="15"
                                    viewBox="0 0 15 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                 >
                                    <g clipPath="url(#clip0_4771_13586)">
                                       <path
                                          d="M3.125 6.875H8.125V8.125H3.125V10L0 7.5L3.125 5V6.875ZM2.5 11.25H4.1925C4.91418 11.8865 5.80418 12.3012 6.7557 12.4443C7.70723 12.5875 8.67986 12.4531 9.55688 12.0572C10.4339 11.6613 11.1781 11.0207 11.7 10.2124C12.222 9.40404 12.4997 8.46224 12.4997 7.5C12.4997 6.53776 12.222 5.59597 11.7 4.78762C11.1781 3.97927 10.4339 3.33871 9.55688 2.94281C8.67986 2.54691 7.70723 2.41249 6.7557 2.55566C5.80418 2.69884 4.91418 3.11354 4.1925 3.75H2.5C3.08166 2.97324 3.83646 2.34282 4.70442 1.90884C5.57238 1.47486 6.52959 1.24927 7.5 1.25C10.9519 1.25 13.75 4.04813 13.75 7.5C13.75 10.9519 10.9519 13.75 7.5 13.75C6.52959 13.7507 5.57238 13.5251 4.70442 13.0912C3.83646 12.6572 3.08166 12.0268 2.5 11.25Z"
                                          fill="white"
                                       />
                                    </g>
                                    <defs>
                                       <clipPath id="clip0_4771_13586">
                                          <rect width="15" height="15" fill="white" />
                                       </clipPath>
                                    </defs>
                                 </svg>
                              </div>
                           </a>
                        ) : null}
                     </div>
                  </li>
               </ul>
            </div>
         </div>
      </nav>
   );
};

const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      entity: state.MeReducer.entity || {},
      unreadNb: state.MeReducer.unreadNotifications || [],
      formsCountByType: state.MeReducer.formsTotalThisYear,
      currentFormsCount: state.MeReducer.currentFormsCount,
      currentSection: state.LeftPanelReducer.showCurrentSection,
      username: state.MeReducer.username,
      role: state.MeReducer.role,
      leftMenuIsOpen: state.LeftPanelReducer.leftMenuIsOpen,
      leftPanelOpen: state.LeftPanelReducer.leftPanelOpen,
      uiTheme: state.AppReducer.ui_theme,
      showSearchTools: state.LeftPanelReducer.showSearchTools,
      layers_stack: state.LayersReducer.layers_stack,
      mapRef: state.MapReducer.mapRef,
      currentSubscription: state.MeReducer.currentSubscription,
      nextBillingDate: state.MeReducer.nextBillingDate,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      setLeftMenuOpen: (e) => dispatch({ type: "SET_LEFT_MENU_OPEN", data: e }),
      setUITheme: (e) => dispatch({ type: "SET_UI_THEME", data: e }),
      showCurrentSection: (e) => dispatch({ type: "SHOW_CURRENT_SECTION", data: e }),
      setLeftPanelWidth: (e) => dispatch({ type: "SET_LEFT_PANEL_WIDTH", data: e }),
      setLeftPanelOpen: (e) => dispatch({ type: "SET_LEFT_PANEL_OPEN", data: e }),
      setCurrentCenterPage: (e) => dispatch({ type: "SET_CURRENT_PAGE", data: e }),
      showCenterSection: (e) => dispatch({ type: "SHOW_CENTER_SECTION", data: e }),
      setOpenPrintControl: (e) => dispatch({ type: "OPEN_PRINT_CONTROL", data: e }),
      setShowSearchPanel: (e) => dispatch({ type: "SHOW_SEARCH_PANEL", data: e }),
      updateUserInfo: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
      setFilterChoice: (e) => dispatch({ type: "CHANGE_FILTER_CHOICE", data: e }),
      setShowPricing: (e) => dispatch({ type: "SET_SHOW_PRICING", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(Navbar);
